import moment from 'moment'

const ACCEPTED_FORMATS = ['DD/MM/YYYY', 'YYYY-MM-DD']

export function formatBackendDate(input, options = {}) {
  const { fallback = 'Fecha inválida', outputFormat = 'DD/MM/YYYY' } = options

  if (input === null || input === undefined || input === '') return ''

  const parsed = moment(input, ACCEPTED_FORMATS, true)
  return parsed.isValid() ? parsed.format(outputFormat) : fallback
}

export default formatBackendDate
